import { Stack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';

import { TableHeadContainer, TableHeadItem } from '../../../../../../components/TableHead';

import { subscriptionSubscriptionHistoryTableHead } from './constants';

export const SubscriptionHistoryHeader = () => {
  return (
    <Stack>
      <TableHeadContainer px={Spacing['inline.xxxs']}>
        {subscriptionSubscriptionHistoryTableHead.map((item, index) => (
          <TableHeadItem key={`${item.title}-${index}`} {...item} />
        ))}
      </TableHeadContainer>
    </Stack>
  );
};
